import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vex-otp-moda',
  templateUrl: './otp-moda.component.html',
  styleUrls: ['./otp-moda.component.scss']
})
export class OtpModaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
